/**
 * @file Compact timer widget for Today view
 */

import { formatElapsed } from '@services/timer.js';

/**
 * Render the active timer widget HTML.
 * @param {Object} timer - Active timer object
 * @returns {string}
 */
export function renderTimerWidget(timer) {
  if (!timer) return '';
  const pauseMs = timer.paused && timer.pauseStart ? Date.now() - timer.pauseStart : 0;
  const elapsed = Math.max(0, Date.now() - timer.startTime - (timer.totalPausedMs || 0) - pauseMs);
  const paused = timer.paused ? ' (Paused)' : '';
  return `
    <div class="timer-widget" id="timer-widget">
      <div class="timer-widget-time" id="timer-widget-time">${formatElapsed(elapsed)}</div>
      <div class="timer-widget-info">
        <div class="timer-widget-job">${escHtml(timer.jobDesc || 'Timer Running')}${paused}</div>
        <div class="timer-widget-customer">${escHtml(timer.customerName || '')}</div>
      </div>
      <span style="font-size:1.2rem;color:var(--gold);">\u23F1</span>
    </div>
  `;
}

function escHtml(str) {
  if (!str) return '';
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
